import React, { useState, useEffect } from "react";
import {
    Button,
    TextField,
    TablePagination,
    IconButton,
    Typography,
    Grid,
    List,
    ListItem,
    Avatar,
    Select,
    MenuItem, 
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import { noImg } from "vrcore-dashboard/dist/utilities";
import styled from "styled-components";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    LocalTaxi as CarIcon,
    Error as ErrorIcon,
    CheckCircle as ArchiveIcon,
    Warning as WarningIcon,
    RemoveRedEye as ViewIcon,
} from "@material-ui/icons";
import { selectAllVehicles } from "../selectors";
import { actionReset } from "../actions";
import { Modal, ModalFooter, ModalBody, Row, Col, Label } from "reactstrap";
import moment from "moment";
import { StyledContent, StyledHeader } from "../../../styles";
import logo from "../inspection.png";
import BuildIcon from "@material-ui/icons/Build";
import "./my-modal.css"

const TableHeadCell = ({ text }) => {
    return (
        // <StyledTableCell>
        <TableCell>
            <Typography variant="body2">
                <b>{text}</b>
            </Typography>
        </TableCell>
        // </StyledTableCell>
    );
};
const TableBodyCell = ({ text = "N/A", style }) => {
    return (
        <TableCell style={style}>
            <Typography variant="body2">{text}</Typography>
        </TableCell>
    );
};
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 10px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;

let arr = [];
let machineReg = "";
let lastInspectionReceipt = "";
let vehReceipts = "";
const VehicleTable = (props) => {
    const [vehicles, setVehicles] = useState(props.vehicles);
    const [userProfile, setUserProfile] = useState(props.userProfile);
    const [actionModal, setActionModel] = useState(false);
    const [actionReset, setActionReset] = useState({});
    // const [machineReg, setMachineReg] = useState("")
    const [live_status, setLiveStatus] = useState("");
    const [action_taken, setActionTaken] = useState("");
    const [date_of_action, setDateOfAction] = useState("");
    const [action_by, setActionBy] = useState(userProfile);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    useEffect(() => {
        setVehicles(props.vehicles);
        setUserProfile(props.userProfile);
    }, [props.vehicles]);
    return (
        <>
            <List style={{ background: "#eee", marginTop: 24 }}>
                <ListItem
                    style={{
                        width: "100%",
                        background: "white",

                        boxShadow:
                            "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                    }}
                >
                    <div style={{ float: "right" }}>
                        <TablePagination
                            colSpan={12}
                            ActionsComponent={TablePaginationHelper}
                            count={vehicles.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={(event, page) => setPage(page)}
                            rowsPerPageOptions={[50, 100]}
                            onChangeRowsPerPage={(event) =>
                                setRowsPerPage(event.target.value)
                            }
                        />
                    </div>
                </ListItem>
                <ListItem
                    style={{
                        minHeight: 60,
                        background: "white",
                        boxShadow:
                            "0 6px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                    }}
                >
                    <Grid container spacing={4}>
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={1}
                                xl={1}
                            >
                                <Typography variant="body2">
                                    <b>Profile</b>
                                </Typography>
                            </Grid>
                        }
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={2}
                                xl={2}
                            >
                                <Typography variant="body2">
                                    <b>Vehicle Details</b>
                                </Typography>
                            </Grid>
                        }
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={2}
                                xl={2}
                            >
                                <Typography variant="body2">
                                    <b>Status</b>
                                </Typography>
                            </Grid>
                        }
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={2}
                                xl={2}
                            >
                                <Typography variant="body2">
                                    <b>Vehicle Inspection / Service</b>
                                </Typography>
                            </Grid>
                        }
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={3}
                                xl={3}
                            >
                                <Typography variant="body2">
                                    <b>Certs</b>
                                </Typography>
                            </Grid>
                        }
                        {
                            <Grid
                                style={{ textAlign: "center" }}
                                item
                                sm={12}
                                md={12}
                                lg={2}
                                xl={2}
                            >
                                <Typography variant="body2">
                                    <b>Actions</b>
                                </Typography>
                            </Grid>
                        }
                    </Grid>
                </ListItem>

                {vehicles
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((vehicle, index) => {
                        let vehicleProfile = vehicle.profile;
                        let vehicleReceipt = vehicle.receipts;
                        return (
                            <StyledListItem
                                borderColor={"#0188cc"}
                                style={{
                                    root: {
                                        borderLeft: "#0188cc",
                                    },
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={1}
                                        xl={1}
                                    >
                                        <Avatar
                                            src={
                                                vehicleProfile.photo_url
                                                    ? vehicleProfile.photo_url
                                                    : noImg
                                            }
                                            style={{
                                                height: 50,
                                                width: 50,
                                                border: "0.5px solid #555",
                                                marginLeft: "20px",
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={2}
                                        xl={2}
                                    >
                                        {vehicleProfile.machine_nickname ===
                                        "" ? (
                                            ""
                                        ) : (
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    paddingLeft: 24,
                                                    fontSize: 12,
                                                }}
                                            >
                                                <b>Nickname: </b>
                                                {
                                                    vehicleProfile.machine_nickname
                                                }
                                            </Typography>
                                        )}
                                        {/* <Typography
                                            variant="body2"
                                            style={{ paddingLeft: 24, fontSize:12 }}
                                        >
                                            <b>Description: </b>
                                            {vehicleProfile.machine_desc}
                                        </Typography> */}
                                        <Typography
                                            variant="body2"
                                            style={{
                                                paddingLeft: 24,
                                                fontSize: 12,
                                            }}
                                        >
                                            <b>Registration: </b>

                                            {vehicleProfile.machine_reg}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{
                                                paddingLeft: 24,
                                                fontSize: 12,
                                            }}
                                        >
                                            <b>Category: </b>
                                            {vehicleProfile.machine_category ===
                                            ""
                                                ? "N/A"
                                                : vehicleProfile.machine_category}
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={2}
                                        xl={2}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{
                                                backgroundColor:
                                                    vehicleProfile.machine_status ===
                                                    "Offline"
                                                        ? "#FF6E40"
                                                        : "white",
                                                fontSize: 12,
                                            }}
                                            text={vehicleProfile.liveStatus}
                                        >
                                            {checkOperational(
                                                vehicleProfile.liveStatus
                                            )}
                                            &nbsp;
                                        </Typography>
                                        <p
                                            style={{
                                                textAlign: "center",
                                                fontSize: 12,
                                            }}
                                        >
                                            {vehicleProfile.liveStatus}
                                        </p>
                                    </Grid>

                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={2}
                                        xl={2}
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{
                                                marginLeft: "0px",
                                                fontSize: 12,
                                            }}
                                            text={vehicleProfile.last_service_date.replace(
                                                /\//g,
                                                "-"
                                            )}
                                        >
                                            {vehicleProfile.lastVehcileInspection ===
                                            "" ? (
                                                <>
                                                    {" "}
                                                    <b
                                                        style={{
                                                            marginLeft: "20px",
                                                        }}
                                                    >
                                                        Last Inspection :{" "}
                                                    </b>{" "}
                                                    N/A <br />
                                                </>
                                            ) : (
                                                <>
                                                    <b>Last Inspection : </b>{" "}
                                                    <br />
                                                    {
                                                        vehicleProfile.lastVehcileInspection
                                                    }{" "}
                                                    <br />
                                                </>
                                            )}

                                            {vehicleProfile.last_service_date ===
                                            "" ? (
                                                <>
                                                    {" "}
                                                    <b
                                                        style={{
                                                            marginLeft: "20px",
                                                        }}
                                                    >
                                                        Last Service Date :{" "}
                                                    </b>{" "}
                                                    N/A <br />
                                                </>
                                            ) : (
                                                // checkDate(vehicleProfile.last_service_date)
                                                <>
                                                    {" "}
                                                    <b>
                                                        Last Service Date :{" "}
                                                    </b>{" "}
                                                    <br />
                                                    {
                                                        vehicleProfile.last_service_date
                                                    }
                                                </>
                                            )}
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={3}
                                        xl={3}
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{ fontSize: 12 }}
                                        >
                                            <b>CRW/NCT/MOT: </b>
                                            {vehicleProfile.machine_nct_expiry}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            style={{ fontSize: 12 }}
                                        >
                                            <b>Tax: </b>
                                            {vehicleProfile.machine_tax_expiry}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ fontSize: 12 }}
                                        >
                                            <b>Insurance: </b>
                                            {vehicleProfile.machine_insurance_expiry ===
                                            ""
                                                ? ""
                                                : vehicleProfile.machine_insurance_expiry}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ fontSize: 12 }}
                                        >
                                            <img
                                                src={logo}
                                                alt="logo"
                                                style={{ width: "34px" }}
                                            />{" "}
                                            {":"}
                                            {vehicleProfile.lastThoroughInspectionDate ===
                                            ""
                                                ? "  N/A"
                                                : vehicleProfile.lastThoroughInspectionDate}
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        style={{
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            display: "grid",
                                        }}
                                        item
                                        sm={12}
                                        md={12}
                                        lg={2}
                                        xl={2}
                                    >
                                        <div
                                            style={{
                                                minWidth: 100,
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <IconButton
                                                style={{
                                                    color: "#0188cc",
                                                    border: "1px solid #0188cc",
                                                    marginRight: 15,
                                                    width: "35px",
                                                    height: "35px",
                                                }}
                                                onClick={() => {
                                                    props.setViewModal(
                                                        vehicle.uid,
                                                        vehicleProfile
                                                    );
                                                }}
                                            >
                                                <CarIcon fontSize="small" />
                                            </IconButton>
                                            {props.canUpdate && (
                                                <IconButton
                                                    style={{
                                                        color: "indigo",
                                                        border:
                                                            "1px solid indigo",
                                                        marginRight: 15,
                                                        width: "35px",
                                                        height: "35px",
                                                    }}
                                                    onClick={() =>
                                                        props.setAddEditModal(
                                                            "edit",
                                                            vehicleProfile,
                                                            vehicle.uid
                                                        )
                                                    }
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                            {vehicleReceipt === null ||
                                            typeof vehicleReceipt ===
                                                undefined ||
                                            props.canUpdate === false ? (
                                                ""
                                            ) : (
                                                <IconButton
                                                    style={{
                                                        color: "indigo",
                                                        border:
                                                            "1px solid indigo",
                                                        marginRight: 15,
                                                        width: "35px",
                                                        height: "35px",
                                                    }}
                                                    onClick={() => {
                                                        machineReg =
                                                            vehicleProfile.machine_reg;
                                                        lastInspectionReceipt =
                                                            vehicleProfile.lastVehcileInspection;
                                                        vehReceipts = vehicleReceipt;
                                                        setActionModel(true);
                                                        arr = actionReset;
                                                        setActionReset(arr);
                                                    }}
                                                >
                                                    <BuildIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                            {props.canDelete && (
                                                <IconButton
                                                    style={{
                                                        color: "red",
                                                        border: "1px solid red",
                                                        width: "35px",
                                                        height: "35px",
                                                    }}
                                                    onClick={() => {
                                                        props.setRemoveModal(
                                                            vehicle.uid,
                                                            vehicleProfile
                                                        );
                                                    }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </StyledListItem>
                        );
                    })}
            </List>

            {/* --------------------------------------Add Action Modal---------------------------- */}
            <div>
                <Modal isOpen={actionModal} className="my-modal">
                    <StyledHeader>
                        <Typography variant="headline">Reset Status</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <ModalRow>
                                <Col>
                                    <Label for="status">Live Status</Label>

                                    <Select
                                        id="status"
                                        value={live_status ? live_status : ""}
                                        style={{ width: "100%" }}
                                        onChange={(event) => {
                                            // let arr = actionReset;
                                            // arr.live_status = event.target.value;
                                            // setActionReset(arr)
                                            setLiveStatus(event.target.value);
                                        }}
                                    >
                                        <MenuItem value="Do Not Use">
                                            Do Not Use
                                        </MenuItem>
                                        <MenuItem value="Temporary Fix">
                                            Temporary Fix
                                        </MenuItem>
                                        <MenuItem value="Clear">Clear</MenuItem>
                                    </Select>
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    <Label for="actiontaken">
                                        Action Taken&nbsp;:&nbsp;&nbsp;
                                    </Label>
                                    <TextField
                                        multiline={true}
                                        style={{
                                            border: "2px solid #0188cc",
                                            borderRadius: "9px",
                                            marginBottom: "11px",
                                            width: "100%",
                                        }}
                                        value={action_taken ? action_taken : ""}
                                        placeholder="Action Taken"
                                        onChange={(event) => {
                                            setActionTaken(event.target.value);
                                        }}
                                    />
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    <Label for="actiondate">Action Date</Label>

                                    <div>
                                        <DayPickerInput
                                            id="actiondate"
                                            placeholder="DD-MM-YYYY"
                                            value={
                                                date_of_action
                                                    ? date_of_action
                                                    : ""
                                            }
                                            style={{
                                                border: "2px solid #0188cc",
                                                borderRadius: "9px",
                                                marginBottom: "11px",
                                                width: "91%",
                                            }}
                                            formatDate={formatDate}
                                            format={"DD-MM-YYYY"}
                                            parseDate={parseDate}
                                            onDayChange={(day) => {
                                                setDateOfAction(
                                                    moment(day).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                );
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <Label for="actiontaken">
                                        Action Taken By&nbsp;:&nbsp;&nbsp;
                                    </Label>
                                    <TextField
                                        multiline={false}
                                        style={{
                                            border: "2px solid #0188cc",
                                            borderRadius: "9px",
                                            marginBottom: "11px",
                                            width: "100%",
                                        }}
                                        value={action_by}
                                        placeholder="Action Taken By"
                                        onChange={(event) => {
                                            setActionBy(event.target.value);
                                        }}
                                    />
                                </Col>
                               
                            </ModalRow>
                            <ModalRow>
                            <Col style={{marginLeft:"-34px"}}>
                                <Table>
                                <TableHead>
                                <TableRow>
                            <TableHeadCell text="Report name" />
                            <TableHeadCell text="Timestamp " />
                            <TableHeadCell text="URN" />
                            <TableHeadCell text="View" />
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                vehReceipts && Object.values(vehReceipts).map((rec,i) => {
                                        return (
                                            <>
                                            <TableRow key={i}>
                                            <TableBodyCell
                                                    text={rec.report_type}
                                                />
                                                <TableBodyCell
                                                    text={rec.timestamp}
                                                />
                                                <TableBodyCell
                                                    text={rec.urn?rec.urn:"N/A"}
                                                />
                                                 <TableCell>

                                             {rec.subject_name==="reports"? <Link
                                                to={`/report-view-standalone/reports/${
                                                    rec.subject_child
                                                }/${rec.report_type.replace(/_/g,"-")}/${
                                                    rec.timestamp
                                                        .replace(/ /g, "_")
                                                        .replace(/:/g, ".")
                                                }`}
                                            > 
                                             
                                                    <IconButton
                                                        style={{
                                                            color: "#0188cc",
                                                            border:
                                                                "1px solid #0188cc",
                                                            margin: "9px"
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Link>:
                                                <Link
                                                to={`/report-view/${rec.subject_name}/${
                                                    rec.subject_child
                                                }/${rec.report_type.replace(/_/g,"-")}/${
                                                    rec.timestamp
                                                        .replace(/ /g, "_")
                                                        .replace(/:/g, ".")
                                                }`}
                                            > 
                                             
                                                    <IconButton
                                                        style={{
                                                            color: "#0188cc",
                                                            border:
                                                                "1px solid #0188cc",
                                                            margin: "9px"
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Link>
                                                }
                                                </TableCell>
                                            </TableRow>
                                            </>

                                        )
                                    }
                                )
                            }
                        </TableBody>
                                </Table>
                                </Col>
                            </ModalRow>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    setActionModel(false);
                                    setActionBy(userProfile);
                                    setDateOfAction("");
                                    setActionTaken("");
                                    setLiveStatus("");
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#0188CC",
                                    color: "white",
                                }}
                                onClick={() => {
                                    let obj = {};
                                    obj["live_status"] = { live_status };
                                    obj["action_taken"] = { action_taken };
                                    obj["date_of_action"] = { date_of_action };
                                    obj["action_by"] = { action_by };
                                    props.actionReset(
                                        machineReg,
                                        live_status,
                                        action_taken,
                                        date_of_action,
                                        action_by,
                                        lastInspectionReceipt
                                    );
                                    setActionModel(false);
                                    setActionBy(userProfile);
                                    setDateOfAction("");
                                    setActionTaken("");
                                    setLiveStatus("");
                                }}
                                disabled={
                                    date_of_action === "" ||
                                    action_taken === "" ||
                                    live_status === ""
                                        ? true
                                        : false
                                }
                            >
                                Submit
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>

            {/* ---------------------------------------------------- */}
        </>
    );
};
// const checkDate = (date) => {
//     let momentDate = moment(date, "DD-MM-YYYY");
//     let currentDate = new moment();
//     let futureDate = moment().add(3, "M");
//     if (momentDate.isBefore(currentDate)) {
//         return <ErrorIcon style={{ color: "#ff6e40" }} />
//     } else if (momentDate.isAfter(futureDate)) {
//         return <ArchiveIcon style={{ color: "green" }} />;
//     } else {
//         return <WarningIcon style={{ color: "yellow" }} />;
//     }
// };
const checkOperational = (status) => {
    if (status === "Operational" || status === "operational") {
        return <ArchiveIcon style={{ color: "green" }} />;
    } else if (
        status === "Do Not Use" ||
        status === "Needing Thorough Inspection" ||
        status === "Certs out of Date" ||
        status === "Needing Service"
    ) {
        return <ErrorIcon style={{ color: "#EF5350" }} />;
    } else {
        return <WarningIcon style={{ color: "#FFCA28" }} />;
    }
};

export default connect(
    (store) => {
        return {
            vehicle: selectAllVehicles(store),
        };
    },
    { actionReset }
)(VehicleTable);
